function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-546 -80) translate(546 80)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.682 15.9c3.363 0 6.542-1.157 6.542-2.38 0-1.497-1.84-3.623-4.4-4.443 1.544-.784 2.604-2.386 2.604-4.232C11.428 2.23 9.299.1 6.682.1 4.066.1 1.937 2.229 1.937 4.845c0 1.846 1.06 3.448 2.603 4.232-2.56.82-4.4 2.946-4.4 4.442 0 1.224 3.18 2.381 6.542 2.381zM2.792 4.845c0-2.145 1.745-3.89 3.89-3.89s3.891 1.745 3.891 3.89-1.746 3.89-3.89 3.89c-2.146 0-3.89-1.745-3.89-3.89zm3.89 4.745c3.286 0 5.687 2.584 5.689 3.917-.098.383-2.27 1.538-5.689 1.538S1.092 13.89.995 13.52c0-1.345 2.402-3.929 5.687-3.929z",
  transform: "translate(-546 -80) translate(546 80) translate(9 8)"
})))));

var SvgWhitePerson = function SvgWhitePerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhitePerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white_person.cdbe0580.svg";
export { ForwardRef as ReactComponent };